<template>
  <section class="flex w-full h-100">
    <nav class="nav">
      <div class="main">
        <EnterpriseDropdown>
          <div class="head-content">
            <div class="item-avatar">
              <Avatar
                :size="24"
                class="editImg mx-[4px]"
                :name="currentOrganization?.organizationName"
                :url="previewFile(currentOrganization?.logo)"
              >
              </Avatar>
            </div>
            <div class="font-bold text-[16px]">
              {{ currentOrganization?.organizationName }}
            </div>
            <span class="free" :style="getAccountTypeStyle(currentOrganization)">{{
              getAccountTypeDesc(currentOrganization)
            }}</span>
            <CaretDownFilled style="color: #999"></CaretDownFilled>
          </div>
        </EnterpriseDropdown>
        <div class="content">
          <div
            class="item-content"
            :class="{ active: route.path === '/settings/member' }"
            @click="goto('/settings/member')"
          >
            <Icon code="xe7ea;" :gutter="8" :size="16"></Icon>
            <div class="item-name">成员管理</div>
          </div>
          <!-- <div
            class="item-content"
            :class="{ active: route.path === '/settings/space' }"
            @click="goto('/settings/space')"
          >
            <Icon code="xe60f;" :gutter="8" :size="16"></Icon>
            <div class="item-name">空间管理</div>
          </div>
          <div
            class="item-content"
            :class="{ active: route.path === '/settings/project' }"
            @click="goto('/settings/project')"
          >
            <Icon code="xe617;" :gutter="8" :size="16"></Icon>
            <div class="item-name">项目管理</div>
          </div> -->
          <div
            class="item-content"
            :class="{ active: route.path === '/settings/enterprise' }"
            @click="goto('/settings/enterprise')"
          >
            <Icon code="xe7ea;" :gutter="8" :size="16"></Icon>
            <div class="item-name">团队设置</div>
          </div>
          <div
            v-if="isPlatformUser"
            class="item-content"
            :class="{ active: route.path === '/settings/parts' }"
            @click="goto('/settings/parts')"
          >
            <Icon code="xe7ea;" :gutter="8" :size="16"></Icon>
            <div class="item-name">平台部件库</div>
          </div>
          <div
            v-if="isPlatformUser"
            class="item-content"
            :class="{ active: route.path === '/settings/resource' }"
            @click="goto('/settings/resource')"
          >
            <Icon code="xe7ea;" :gutter="8" :size="16"></Icon>
            <div class="item-name">资源中心</div>
          </div>
        </div>
        <div class="bottom-line"></div>
        <div class="bottom">
          <div class="bottom-left" @click="goto('/workbench')">
            <Icon code="xe613;" :gutter="4" :size="16"> </Icon>
            <div class="left-name">返回工作台</div>
          </div>
        </div>
        <!-- <RouterLink to="/workbench">返回工作台</RouterLink> -->
      </div>
    </nav>
    <main class="main w-full flex flex-col overflow-x-hidden">
      <UserBar>
        <!-- <template #extra>
          
        </template> -->
      </UserBar>
      <div style="padding: 0 0 0 16px; flex: 1; overflow: hidden">
        <RouterView></RouterView>
      </div>
    </main>
  </section>
</template>

<script setup lang="ts">
import { RouterView, RouterLink, useRoute } from 'vue-router'
import { Icon } from '@elecmap/icon'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import useUserStore from '@/store/user'
import UserBar from '../components/user-bar.vue'
import { Avatar } from '@elecmap/elecmap-ui'
import { getAccountTypeDesc, getAccountTypeStyle, useOrganization } from '@/store/organization'
import { previewFile } from '@elecmap/api/src/cad/file'
import EnterpriseDropdown from '@/components/user-menu/enterprise-dropdown.vue'
import { CaretDownFilled } from '@ant-design/icons-vue'

const route = useRoute()
const router = useRouter()
const { userInfo, isPlatformUser } = storeToRefs(useUserStore())
const { currentOrganization } = storeToRefs(useOrganization())

function goto(path: string) {
  router.push({ path })
}
</script>

<style scoped lang="scss">
.nav {
  flex: 0 0 225px;
  position: relative;
  .main {
    // margin: 15px 18px 0;
    padding: 24px 16px 0;
  }
}

.main {
  .head-content {
    display: flex;
    align-items: center;
  }

  .content {
    margin-top: 24px;

    .item-content {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin: 2px -4px;
      padding: 4px 8px;
      border-radius: 3px;
      transition: background-color 0.2s ease-in-out;

      .item-name {
        font-size: 13px;
      }

      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }

      &.active {
        background-color: rgba(0, 142, 250, 0.1) !important;
      }
    }
  }

  .bottom-line {
    position: absolute;
    bottom: 32px;
    width: 196px;
    height: 1px;
    transform: translateX(-8px);
    background-color: #ddd;
  }

  .bottom {
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-55%);
    display: flex;
    justify-content: center;
    align-items: center;
    // border-top: 1px #ddd solid;

    .bottom-left {
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;

      .left-name {
        // margin-left: 4px;
      }
    }

    .bottom-middle {
      height: 20px;
      width: 1px;
      background-color: #bbb;
    }

    .bottom-right {
      display: flex;
      cursor: pointer;
    }
  }
}
</style>
